import React, { Component } from 'react';
import PropTypes from 'prop-types';
import StripeChargeNBU from '../StripeChargeNBU';


class ChargeModalNBU extends Component {
    constructor(props) {
        super(props);
        this.state = {}

    }

    render() {
        const { clouseModal, booking, show_members, cbCharge, default_price,dateTime } = this.props;
        
        return (
            <div className="modal stripe-modal active">
                <div className="modal-content">
                    <div className="close-btn">
                        <button onClick={clouseModal}>
                            <img src="/assets/img/cancel.png" alt="cancel" />
                        </button>
                    </div>
                    <StripeChargeNBU
                        dateTime={dateTime}
                        booking={booking}
                        waitlist={this.props.waitlist}
                        member_type_id={this.props.member_type_id}
                        from={this.props.from}
                        cbCharge={cbCharge}
                        default_price={default_price}
                        show_members={show_members}
                        outerState={this.props.outerState ? this.props.outerState : null}
                        uid={this.props.uid}
                        stripeUserId={this.props.stripeUserId}
                        clouseModal={this.props.clouseModal}
                        clouseModalRoot={this.props.clouseModalRoot}
                    />
                </div>
            </div>
        );
    }
}

ChargeModalNBU.propTypes = {
    clouseModal: PropTypes.func.isRequired,
    //uid: PropTypes.string.isRequired,
    stripeUserId: PropTypes.string,
};
ChargeModalNBU.defaultProps = {
    stripeUserId: null
};
export default ChargeModalNBU;
